import cx from 'classnames'
import NextLink from 'next/link'
import { useContext } from 'react'

import { SanityPrintShop } from '@data/sanity/queries/types/shop'
import { getPageUrl, PageType } from '@lib/routes'
import { StringsContext } from '@lib/strings-context'

import Icon from '@components/icon'

interface ProductBackLinkProps {
  printShop: SanityPrintShop
  className?: string
}

const ProductBackLink = ({ printShop, className }: ProductBackLinkProps) => {
  const strings = useContext(StringsContext)

  const printShopUrl = getPageUrl(PageType.PRIVATE_SHOP_PAGE, [printShop.slug])

  return (
    <NextLink
      href={printShopUrl}
      className={cx('items-center gap-1', className)}
    >
      <Icon name="ArrowLeft" className="text-[22px]" />
      <span className="text-base font-medium">{strings.buttonGoBack}</span>
    </NextLink>
  )
}

export default ProductBackLink
